import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-cyan-glow text-[#00D4FF] font-mono-data tracking-[0.3em] text-xs">
        ESTABLISHING UPLINK…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
